module.exports = __webpack_public_path__ + "img/hohlsaum_moosgruen_ral6005.32a0ac72.jpg";